module.exports = __webpack_public_path__ + "assets/img/driver-active-btn-bc09d5f0.png";